/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamStudentSupervisorViewResponse } from './oralExamStudentSupervisorViewResponse';

export type OralExamRunStateResponseSupervisorView = OralExamStudentSupervisorViewResponse | null;
